<template>
    <div class="common-body" @click="onClick">
        <div class="common-body common-ellipsis" v-if="type === TableTypes.String">{{ value || '无' }}</div>
        <div class="common-body common-ellipsis" v-if="type === TableTypes.Number">{{ value || 0 }}</div>
        <div class="common-body" v-else-if="type === TableTypes.ContactVerify">
            <el-tag type="success" v-if="value">已验证</el-tag>
            <el-tag type="danger" v-else>未验证</el-tag>
        </div>
        <div class="common-body" v-else-if="type === TableTypes.Lock">
            <el-tag type="danger" v-if="value">锁定</el-tag>
            <el-tag type="success" v-else>未锁定</el-tag>
        </div>
        <div class="common-body" v-else-if="type === TableTypes.Date">
            <span v-if="value">{{moment(value).format('YYYY-MM-DD')}}</span>
            <span v-else></span>
        </div>
        <div class="common-body" v-else-if="type === TableTypes.DateTime">
            {{moment(value).format('YYYY-MM-DD HH:mm:ss')}}
        </div>
        <div class="common-body" v-else-if="type === TableTypes.Status">
            {{ checkStatus(value).label }}
        </div>
        <div class="common-body" v-else-if="type === TableTypes.Stake">
            {{ Tools.get().Convert.convertStake(value) }}
        </div>
        <div class="common-body" v-else-if="type === TableTypes.Smile">
            <d2-icon name="smile-o" style="font-size: 24px;" v-if="value"></d2-icon>
            <d2-icon name="frown-o" style="font-size: 24px;" v-else></d2-icon>
        </div>
        <!-- 以下为Jun拓展 -->
        <div class="common-body" v-else-if="type === 'enum1'">
            <div v-for="(item,index) in enums.enum1" :key="index">
                <span v-if="item.value === value">{{item.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'PageColumnItem',
        methods: {
            checkStatus(status) { // 检查状态
                return this.Status.Status.checkStatus(status)
            },
            checkType(type) {
                return type === this.type
            },
            onClick(){
                this.$emit('column-item-click', this.value, this.row, this.$index)
            }
        },
        props: {
            value: [String, Number, Boolean, Object],
            type: {
                type: String,
                default: 'String'
            },
            row: [Object],
            $index: [Number]
        },
        data() {
            return {
                enums:{
                    enum1:[{label:'项目级',value:'1'},{label:'路网级',value:'2'}]
                }
            }
        }
    }
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageColumnItem.vue"
}
</vue-filename-injector>
